import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import LabelField from "../components/LabelField";
import { checkNullValue, groupNameGetter } from "../utils/Util";
import SelectInput from "../components/SelectInput";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { updateUserApi } from "../api/roleMasterApi";
import { toast } from "react-toastify";

interface ViewUserDetailsModalProps {
    userData: any,
    toggle : (data?: any) => void,
    openViewModal: boolean,
    setFlag: (data: any) => void
}

interface UpdateData {
    role: string[];
    grdsStatus: string;
}

const ViewUserDetailsModal = ({
    userData,
    toggle,
    openViewModal,
    setFlag
}: ViewUserDetailsModalProps) => {

    const closeBtn = (
        <img 
            src={require('../assets/img/close_modal.svg').default} 
            onClick={() => { toggle(); setFlag(false)}} 
            style={{ cursor: 'pointer' }}
        ></img>
    );

    const {
        register,
        handleSubmit,
        watch,
        getValues,
        setValue,
        formState: { errors },
    } = useForm<UpdateData>();

    const updateData = useForm<UpdateData>({
        defaultValues: {
            role: [],
            grdsStatus: ''
        },
        mode: 'all',
    });

    const grdsStatus = watch('grdsStatus');
    const role = watch('role');
    const dispatch: any = useDispatch();
    const [isFormDisabled, setIsFormDisabled] = useState(true);

    const {
        roleStatusStore,
        storeUpdateUserResponse,
        storeAllRoles
    } = useSelector((state: any) => state.roleMaster);

    const roleStatusData = roleStatusStore ?? [];
    const [roleList, setRoleList] = useState<any>([]);

    useEffect(() => {
        let roles = storeAllRoles.map((role: any, i: number) => {
            return { label: role.name, value: i, status: role.status}
        })
        setRoleList(roles)
    },[storeAllRoles])

    const onChangeInput = (label: any, value: any,) => {
        setValue(label, value, { shouldValidate: true })
    }

    const onSubmit = (data: UpdateData) => {
        if(!(data?.role?.length > 0)) {
            toast.warn('Please select a role');
        }
        else{
            dispatch(updateUserApi(data, userData?.email, userData?.groupName));
        }
    };
    
    useEffect(() => {
        setValue('role', userData?.groupName, { shouldValidate: true });
        setValue('grdsStatus', checkNullValue(userData?.groupName) != 'N/A' ? 'Active' : 'Inactive', { shouldValidate: true });
    },[])

    useEffect(() => {
        if(storeUpdateUserResponse?.response === 'updated Successfully'){
            toggle();
            setFlag(true);
        }
    },[storeUpdateUserResponse])

    const checkFormDisabilty = () => {
        let userStatus = checkNullValue(userData?.groupName) != 'N/A' ? 'Active' : 'Inactive';
        let isRoleUpdated = !((role?.length === userData?.groupName?.length) && role?.every((item: any) => {return userData?.groupName?.includes(item)}));
        if(
            !isRoleUpdated &&
            grdsStatus === userStatus
        ) {
            return true;
        }
        else {
            return false;
        }
    }

    useEffect(() => {
        setIsFormDisabled(checkFormDisabilty());
    },[role, grdsStatus])

    return (
        <Modal isOpen={openViewModal} toggle={toggle} centered={true} size="lg" backdrop={'static'}>
            <ModalHeader toggle={toggle} close={closeBtn}>
                {userData?.firstName + ' ' + (userData.lastName ? userData.lastName : '')}
            </ModalHeader>
            <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                <ModalBody>
                    <>
                        <Row>
                            <Col xs={6} md={4} className="mb-3">
                                <LabelField name='Employee ID'></LabelField>
                                <p className='grievance-details'>{checkNullValue(userData?.empId)}</p>
                            </Col>
                            <Col xs={6} md={4} className="mb-3">
                                <LabelField name='Employee Name'></LabelField>
                                <p className='grievance-details'>{checkNullValue(userData?.firstName + ' ' + (userData.lastName ? userData.lastName : ''))}</p>
                            </Col>
                            <Col xs={6} md={4} className="mb-3">
                                <LabelField name='Email ID'></LabelField>
                                <p className='grievance-details'>{checkNullValue(userData?.email)}</p>
                            </Col>
                            <Col xs={6} md={4} className="mb-3">
                                <LabelField name='Department'></LabelField>
                                <p className='grievance-details'>{groupNameGetter(userData, 'groupName')}</p>
                            </Col>
                            <Col xs={6} md={4} className="mb-3">
                                <LabelField name='Mobile'></LabelField>
                                <p className='grievance-details'>{checkNullValue(userData?.mobile)}</p>
                            </Col>
                            <Col xs={6} md={4} className="mb-3">
                                <LabelField name='AD Status'></LabelField>
                                <p className='grievance-details'>Active</p>
                            </Col>
                            <Col xs={6} md={4} className="mb-3">
                                <LabelField name='Company'></LabelField>
                                <p className='grievance-details'>KSHEMA GENERAL INSURANCE LIMITED</p>
                            </Col>
                            <Col xs={6} md={4} className="mb-3">
                                <LabelField name='Role'></LabelField>
                                <SelectInput 
                                    changeFun={onChangeInput}
                                    formValue={role}
                                    valueName={'role'}
                                    register={register('role')}
                                    data={roleList}
                                    className = {'custom-input'}
                                    isMultiple = { true }
                                />
                            </Col>
                            <Col xs={6} md={4} className="mb-3">
                                <LabelField name='GRDS Status'></LabelField>
                                <SelectInput 
                                    changeFun={onChangeInput}
                                    formValue={grdsStatus}
                                    valueName={'grdsStatus'}
                                    register={register('grdsStatus')}
                                    data={roleStatusData}
                                    className = {'custom-input'}
                                />
                            </Col>
                        </Row>
                    </>
                </ModalBody>
                <ModalFooter>
                <Button 
                    type='submit' 
                    className="button" 
                    style={{ width: '91px' }}
                    disabled={isFormDisabled}
                >
                    Submit
                </Button>{' '}
                <Button onClick={() => { toggle(); setFlag(false);}} className="resetButton" style={{ width: '91px' }}>
                    Cancel
                </Button>
                </ModalFooter>
            </form>
        </Modal>
    );
}


export default ViewUserDetailsModal;